
<template>
  <div>
    <v-page-toolbar :title="$t('_menu.incidents')" icon="receipt">
      <template v-slot:buttons>
        <v-divider class="mx-5" inset vertical />
        <v-row>
          <v-col cols="12" sm="6" md="3">
            <v-dialog
              ref="modal"
              v-model="modal"
              :return-value.sync="filterEndDate"
              dense
              persistent
              width="290px"
              :close-on-content-click="false"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  hide-details
                  v-model="filterEndDate"
                  :label="$t('_incident.incident') + ' ' + $t('_date.endDate')"
                  prepend-icon="edit_calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="filterEndDate"
                scrollable
                :first-day-of-week="1"
                :locale="lang"
              >
                <v-btn text color="primary" @click="clearEndDate">
                  {{ $t("common.clear") }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="modal = false">
                  {{ $t("common.cancel") }}
                </v-btn>
                <v-btn text color="primary" @click="filterEndDatee">
                  {{ $t("common.ok") }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-col>
        </v-row>
        <v-btn color="success" dark class="mb-2" @click="dialog = true">
          <v-icon dark left>add_circle_outline</v-icon>
          {{ $t("common.new").toLocaleUpperCase(lang) }}
          {{ $t("_incident.incident").toLocaleUpperCase(lang) }}
        </v-btn>
        
      </template>
    </v-page-toolbar>
    <v-layout row wrap fluid>
      <v-flex lg12>
        <incident-table
          :filter.sync="filter"
          :filterEndDate.sync="filterEndDate"
          :incidentItems="filterIncidents"
          :groupId="routeId"
          :counties="counties"
          :neighborhoods="neighborhoods"
          @placeClick="placeClick"
          @placeReClick="placeReClick"
        />
      </v-flex>
    </v-layout>
    <new-incident-button
          :dialog.sync="dialog"
          :editedItem="newItem"
          :editedIndex="itemIndex"
          :counties="counties"
          :incidentTypes="incidentTypes"
          :neighborhoods="neighborhoods"
          :routeName="routeName"
          :categoryId="routeId"
          @confirmed="onConfirmed"
          @cancelled="onCancelled"
        />
    <VMap
      :categoryId="routeId"
      :showPoints="incidents"
      showType="incidents"
      :mapCenter.sync="center"
      :mapZoom.sync="zoom"
      :showPlaceInfo.sync="showDialog"
      :showPlaceCoord="placeCoord"
      :selectedPlace="selectedItem"
    />
  </div>
</template>

<script>
import IncidentTable from "./IncidentTable";
import VMap from "@/components/ui/VMap.vue";
import NewIncidentButton from "./NewIncidentButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: { IncidentTable, VMap, NewIncidentButton },

  async created() {
    const jwt = this.$store.getters["auth/jwtDecoded"];
    if (jwt.city_code === "59") {
      this.center = [27.511675, 40.978092];
      this.cityCenter = [27.511675, 40.978092];
    } else {
      this.center = [36.33534518345682, 41.295020754851635];
      this.cityCenter = [36.33534518345682, 41.295020754851635];
    }
    this.getCounties();
    this.getNeighborhoods();
    this.getIncidentTypes();
    this.filter = JSON.parse(JSON.stringify(this.emptyIncidentFilter));
  },

  data() {
    return {
      routeId: "7166c32d-b6f9-4a97-85c4-0124acb2713b",
      routeName: "",
      filter: {},
      emptyFilter: {
        name: "",
        cityCode: null,
        countyCode: null,
        categoryIds: [],
      },
      emptyIncidentFilter: {
        cityCode: null,
        countyCode: null,
        fetchAfter: null,
      },
      newItem: {
        incidentType: {
          id: "",
          name: "",
        },
        description: "",
        countyCode: null,
        neighborhoodCode: "",
        lat: "",
        lon: "",
        startDate: "",
        endDate: "",
        startTime: null,
        endTime: null,
      },
      dialog: false,
      itemIndex: -1,
      page: 0,
      totalItemsPerPage: 10000,
      places: null,
      center: [],
      cityCenter: [],
      zoom: 9,
      showDialog: false,
      placeCoord: [],
      selectedItem: null,
      filterEndDate: null,
      modal: false,
      sortField: "endTime",
      sortOrder: -1,
    };
  },
  computed: {
    ...mapGetters({ counties: "cities/counties" }),
    ...mapGetters({ neighborhoods: "cities/neighborhoods" }),
    ...mapGetters({ incidents: "incidents/items" }),
    ...mapGetters({ incidentTypes: "incidents/incidentTypes" }),
    ...mapGetters({ language: "app/language" }),
    lang() {
      return this.language.replaceAll("_", "-");
    },
    filterIncidents() {
      return this.incidents.map((item) =>
        Object.assign({}, item, {
          countyName: (
            this.counties.find((county) => county.code === item.countyCode) ||
            {}
          ).name,
          neighborhoodName: (
            this.neighborhoods.find(
              (neighborhood) => neighborhood.code === item.neighborhoodCode
            ) || {}
          ).name,
          startTimeTable:
            new Date(item.startTime).toLocaleDateString(this.lang) +
            " " +
            new Date(item.startTime).toLocaleTimeString(this.lang),
          endTimeTable:
            new Date(item.endTime).toLocaleDateString(this.lang) +
            " " +
            new Date(item.endTime).toLocaleTimeString(this.lang),
        })
      );
    },
  },
  methods: {
    ...mapActions(["cities/getCountiesByCity"]),
    ...mapActions(["cities/getNeighborhoodsByCity"]),
    ...mapActions(["incidents/getItems"]),
    ...mapActions(["incidents/getIncidentTypes"]),

    async refreshTable() {
      console.log("after confirm");
      this.filter.fetchAfter = this.filterEndDate;
      let filterr = JSON.parse(JSON.stringify(this.filter));
      //filterr.categoryIds.push(this.routeId);
      await this.$store.dispatch("incidents/getItems", {
        page: this.page,
        itemsPerPage: this.totalItemsPerPage,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        filter: filterr,
      });
    },
    async getCounties() {
      await this.$store.dispatch("cities/getCountiesByCity");
      this.counties.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    async getNeighborhoods() {
      let filterr = JSON.parse(JSON.stringify(this.filter));
      await this.$store.dispatch("cities/getNeighborhoodsByCity", {
        page: 0,
        itemsPerPage: 2000,
        filter: filterr,
      });
      this.neighborhoods.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    async getIncidentTypes() {
      await this.$store.dispatch("incidents/getIncidentTypes");
      this.incidentTypes.sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
    },
    onConfirmed(editedItem) {
      // hide a dialog
      this.dialog = false;
      this.refreshTable();
      // save a user and refresh a table
    },
    onCancelled() {
      // hide a dialog
      this.dialog = false;
    },
    placeClick(item) {
      console.log("placetable", item);
      console.log("son adım");
      this.center = [item.lon, item.lat];
      this.placeCoord = [item.lon, item.lat];
      this.zoom = 16;
      this.showDialog = false;
      this.selectedItem = item;
    },
    placeReClick() {
      this.center = this.cityCenter;
      this.zoom = 9;
      this.showDialog = false;
      this.selectedItem = null;
    },

    filterEndDatee() {
      // Close the date picker.
      this.$refs.modal.save(this.filterEndDate);
      this.refreshTable();
    },
    clearEndDate() {
      // Close the date picker.
      this.$refs.modal.save();
      this.filterEndDate = null;
      this.refreshTable();
    },
  },
};
</script>
